// 酒店相关
export default [
    {
        path: '/hotel/introdution',
        component: () => import(/* webpackChunkName:"hotel-introdution"*/'@/pages/hotel/introduction/index.vue'),
        name: 'HotelIntroduction',
        meta: {
            // 酒店详情介绍页
            title: '酒店详情',
        },
    },
    {
        path: '/hotel/activity-space',
        component: () => import(/* webpackChunkName:"hotel-activitySpace"*/'@/pages/hotel/activitySpace/space.vue'),
        name: 'activitySpace',
        meta: {
            // 活动空间展示页
            title: '活动空间',
            keepAlive: true,
            scrollTop: 0,
        },
    },
    {
        path: '/hotel/activity-space-city',
        component: () => import(/* webpackChunkName:"hotel-activitySpaceCity"*/'@/pages/hotel/activitySpace/city.vue'),
        name: 'activitySpaceCity',
        meta: {
            // 活动空间展示页
            title: '活动空间',
            keepAlive: true,
            scrollTop: 0,
        },
    },
    {
    // 酒店会议室售卖
        path: '/hotel/meeting-list',
        component: () => import(/* webpackChunkName:"hotel-meetingList"*/'@/pages/hotel/meeting-sell/MeetingList.vue'),
        name: 'MeetingList',
        meta: {
            title: '活动空间',
        },
    },
    {
    // 酒店会议室详情
        path: '/hotel/meeting-detail',
        component: () => import(/* webpackChunkName:"hotel-meetingDetail"*/'@/pages/hotel/meeting-sell/MeetingDetail.vue'),
        name: 'MeetingDetail',
        meta: {
            title: ' 活动空间',
        },
    },
    {
        path: '/hotel/roomTypeDetail',
        component: () => import(/* webpackChunkName:"hotel-roomTypeDetail"*/'@/pages/hotel/roomTypeDetail/roomTypeDetail.vue'),
        name: 'roomTypeDetail',
        meta: {
            title: '房型详情',
        },
    },
    {
        path: '/hotel/hightLightDetail',
        component: () => import(/* webpackChunkName:"hotel-hightLightDetail"*/'@/pages/hotel/hightLightDetail/index.vue'),
        name: 'hightLightDetail',
        meta: {
            title: '亮点详情',
        },
    },
    {
        path: '/hotel/requisitionInfo',
        component: () => import(/* webpackChunkName:"hotel-requisitionInfo"*/'@/pages/hotel/requisitionInfo/index.vue'),
        name: 'RequisitionInfo',
        meta: {
            title: '亚朵酒店征用信息填写',
        },
    },
];
